<template>
  <div class="input-box-holder" v-validate="errors" v-has-value="cardDelivery.deliveryType">
    <div class="validation-output text-left mb-10">
      <ErrorHandler class="error" id="V122">
        You have not selected any of the options. To continue, please select one option.
      </ErrorHandler>
    </div>

    <RadioButton
      class="input-box rd-card heading-4 weight-medium"
      title='Deliver the Health Insurance Card by Post'
      v-model="cardDelivery.deliveryType"
      :option="CardDeliveryTypeEnum.POST"
      :checked="true"
    >
      <ul class="body-3 weight-regular pt-5">
        <li>
          Free Delivery by Slovak Post
        </li>
      </ul>

      <div v-if="cardDelivery.deliveryType === CardDeliveryTypeEnum.POST">
        <h4 class="weight-medium mt-10">
          Deliver the health insurance card to:
        </h4>

        <div>
          <AddressCard v-if="person.hasTemporaryResidence" class="mt-10">
            <p>{{ `${person.temporaryResidence.street} ${person.temporaryResidence.streetNumber}`}}</p>
            <p>{{ `${person.temporaryResidence.zip} ${person.temporaryResidence.city}` }}</p>
            <p>{{ `${person.temporaryResidence.country ? person.temporaryResidence.country.label : ''}` }}</p>
          </AddressCard>
          <AddressCard v-else-if="person.postalAddressSameAsAddress" class="mt-10">
            <p>{{ `${person.address.street} ${person.address.streetNumber}`}}</p>
            <p>{{ `${person.address.zip} ${person.address.city}` }}</p>
            <p>{{ `${person.address.country ? person.address.country.label : ''}` }}</p>
          </AddressCard>
          <AddressCard v-else class="mt-10">
            <p>{{ `${person.postalAddress.street} ${person.postalAddress.streetNumber}`}}</p>
            <p>{{ `${person.postalAddress.zip} ${person.postalAddress.city}` }}</p>
            <p>{{ `${person.postalAddress.country ? person.postalAddress.country.label : ''}` }}</p>
          </AddressCard>
        </div>
      </div>
    </RadioButton>

    <RadioButton
      class="input-box rd-card mt-10 heading-4 weight-medium"
      title='Collect the Health Insurance Card in Person'
      v-model="cardDelivery.deliveryType"
      :option="CardDeliveryTypeEnum.CONTACT_PLACE"
      :checked="true"
    >
      <ul class="body-3 weight-regular pt-5">
        <li>
          Select from 43 Available Contact Points
        </li>
      </ul>

      <div v-if="cardDelivery.deliveryType === CardDeliveryTypeEnum.CONTACT_PLACE">
        <div class="input-box-holder mt-10" v-validate="errors">
          <SelectField
            class="input-box"
            title='Collect the health insurance card at the following contact point:'
            :options="contactPlaces"
            :value="contactPlace"
            @input="setContactPlace"
            required
            valueOnlyFromOptions
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" id="V230">
              Select a contact point.
            </ErrorHandler>
          </div>
        </div>

        <div class="input-box-holder mt-10" v-validate="errors" v-has-value="insurer.email">
          <TextField
            class="input-box"
            title='Enter Your E-mail to Receive a Notification'
            @input="setEmail"
            :value="insurer.email"
            required
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" id="V009">
              Enter your e-mail.
            </ErrorHandler>

            <ErrorHandler class="error" id="V010">
              Enter your e-mail in the correct format.
            </ErrorHandler>

            <ErrorHandler class="error" id="V011">
              The maximum number of characters is 50.
            </ErrorHandler>
          </div>
        </div>
      </div>
    </RadioButton>
  </div>
</template>
<script>
import AddressCard from '@/components/AddressCard/AddressCard.vue';
import SelectField from '@/components/SelectField/SelectField.vue';
import TextField from '@/components/TextField/TextField.vue';
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import enums from '@/mixins/enums';
import { areCodesValid } from '@/utils/validations';

export default {
  components: {
    RadioButton, TextField, SelectField, AddressCard, ErrorHandler,
  },
  mixins: [enums],
  props: {
    cardDelivery: { type: Object, required: true },
    person: { type: Object, required: true },
    insurer: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  mounted() {
    if (this.cardDelivery.deliveryType === this.CardDeliveryTypeEnum.POST) {
      this.setAddressWhenPostal();
    }
  },
  computed: {
    CardDeliveryTypeEnum() {
      return this.enums.CardDeliveryTypeEnum;
    },
    contactPlaces() { return this.$store.state.contactPlaces; },
    contactPlace() { return this.contactPlaces?.find((place) => place.id === this.cardDelivery.contactPlace?.id); },
  },
  methods: {
    setAddressWhenPostal() {
      const { OTHER_ADDRESS } = this.enums.CardDeliveryAddressTypeEnum;
      if (this.person.hasTemporaryResidence) {
        this.cardDelivery.deliveryAddress = this.person.temporaryResidence;
      } else {
        this.cardDelivery.deliveryAddress = this.person.postalAddressSameAsAddress ? this.person.address : this.person.postalAddress;
      }
      this.cardDelivery.deliveryAddressType = OTHER_ADDRESS;
      this.cardDelivery.deliveryAddress.country = this.$store.getters.getSlovakia;
    },
    setContactPlace(place) {
      this.cardDelivery.contactPlace = { email: place?.email, id: place?.id, number: place?.number };
    },
    setEmail(email) {
      this.insurer.email = email.replace(/\s+/g, '');
      this.$nextTick(() => {
        if (areCodesValid(['V009', 'V010', 'V011'], this.errors)) {
          if (this.model.lastStep < 7) this.model.delivery.email = this.model.insurer.email;
        }
      });
    },
  },
  async created() {
    if (!this.$store.state.contactPlaces.length) {
      await this.$store.dispatch('getContactPlaces');
    }
  },
  watch: {
    'cardDelivery.deliveryType': {
      handler(newValue) {
        if (newValue === this.CardDeliveryTypeEnum.POST) {
          this.setAddressWhenPostal();
        }
      },
    },
  },
};
</script>
